// MUI
import { Box, IconButton } from '@mui/material';

// Custom components
import CustomButton from 'components/Button/CustomButton';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import LinkIcon from '@mui/icons-material/Link';
import useResponsive from 'utils/CustomHooks/useResponsive';

const ChecklistLogReportHeader = function ({
  handleDownloadPDF,
  isDownloading,
  handleShareClick,
  isPublic,
  logo = '',
}) {
  const { isMobileDeviceSm } = useResponsive();

  return (
    <header className="d-flex justify-content-between align-items-center main-header px-3 border-1 border-bottom mb-4">
      <Box></Box>
      {isMobileDeviceSm ? (
        <div>
          {!isPublic && (
            <IconButton onClick={handleShareClick}>
              <LinkIcon fontSize="small" />
              {/*Share Report*/}
            </IconButton>
          )}
          <IconButton onClick={handleDownloadPDF}>
            <FileDownloadOutlinedIcon fontSize="small" />
            {/*Download PDF*/}
          </IconButton>
        </div>
      ) : (
        <div>
          {!isPublic && (
            <CustomButton
              className="download-pdf-btn"
              variant="outlined"
              sx={{ borderRadius: '6px', marginRight: '8px' }}
              startIcon={<LinkIcon fontSize="small" />}
              onClick={handleShareClick}
            >
              Share Report
            </CustomButton>
          )}
          <CustomButton
            className="download-pdf-btn"
            variant="contained"
            sx={{ borderRadius: '6px' }}
            startIcon={<FileDownloadOutlinedIcon fontSize="small" />}
            buttonLoader={isDownloading}
            onClick={handleDownloadPDF}
          >
            Download PDF
          </CustomButton>
        </div>
      )}
    </header>
  );
};

export default ChecklistLogReportHeader;
